import { Amplify } from 'aws-amplify';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Gated on import.meta.env.DEV so the skip-Amplify branch is dropped from
// prod builds — production always configures Cognito.
const isLocal =
  import.meta.env.DEV &&
  import.meta.env.VITE_COGNITO_USER_POOL_ID?.startsWith('local');

if (!isLocal) {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
        userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
        loginWith: {
          email: true,
          oauth: {
            domain: 'myiq-auth.auth.ca-central-1.amazoncognito.com',
            scopes: ['email', 'profile', 'openid'],
            redirectSignIn: ['https://app.bennwokoye.com/auth/callback'],
            redirectSignOut: ['https://app.bennwokoye.com'],
            responseType: 'code',
          },
        },
      },
    },
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
